// extracted by mini-css-extract-plugin
export var card = "ArticleCallOutCard-module--card--HUhRa";
export var iconCircle = "ArticleCallOutCard-module--iconCircle--3_h_W";
export var icon = "ArticleCallOutCard-module--icon--2oto-";
export var title = "ArticleCallOutCard-module--title--2HsGd";
export var text = "ArticleCallOutCard-module--text--1a6RT";